<template>
  <g>
    <path
      d="M17.0025 2C17.2625 2 17.5125 2.1 17.7125 2.29C18.1025 2.68 18.1025 3.31 17.7125 3.7L9.4225 11.99L17.7125 20.29C18.1025 20.68 18.1025 21.32 17.7125 21.71C17.3225 22.1 16.6825 22.1 16.2925 21.71L7.2925 12.71C6.9025 12.32 6.9025 11.69 7.2925 11.3L16.2925 2.29C16.4925 2.09 16.7425 2 17.0025 2Z"
    />
  </g>
</template>
